/**
 * axios 请求拦截器 - 自动添加 JWT token
 */
import axios from 'axios';

const TOKEN_KEY = 'token';

export function getToken() {
  return localStorage.getItem(TOKEN_KEY);
}

export function setAuthToken(token) {
  localStorage.setItem(TOKEN_KEY, token);
}

export function clearAuthToken() {
  localStorage.removeItem(TOKEN_KEY);
}

// 添加请求拦截器，所有 axios 请求自动带上 Authorization header
axios.interceptors.request.use(
  (config) => {
    const token = getToken();
    if (token) {
      config.headers['Authorization'] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// 响应拦截器 - 处理 401 未授权
axios.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response && error.response.status === 401) {
      const requestUrl = error.config?.url || '';
      if (requestUrl.includes('/api/auth/login')) {
        return Promise.reject(error);
      }
      // token 过期或无效，清除本地登录状态，跳转登录页
      clearAuthToken();
      localStorage.removeItem('username');
      localStorage.removeItem('user_id');
      localStorage.removeItem('nickname');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default axios;
